import clsx from 'clsx';
import { Heading } from '../../../../v2/js/components/heading';
import { MAIN_CONTENT_AREA } from '../../../../v2/js/utils/layoutStyles';
import { TRANSITION_ALL } from '../../../../v2/js/utils/transitionStyles';
import { useDocumentTitle } from '../../../app/hooks/use-document-title';
import { ProviderList } from './ProviderList';

export function HealthcareEntityProviderList() {
  useDocumentTitle('Healthcare Organization Providers');

  return (
    <div className="tw:flex tw:h-[calc(100vh-72px)] tw:overflow-hidden">
      {/* Main content area */}
      <div className={clsx(`tw:flex tw:flex-col ${TRANSITION_ALL} tw:overflow-hidden tw:w-full`)}>
        <main className={MAIN_CONTENT_AREA}>
          <Heading level={1} className="tw:!text-brand-green-0 tw:dark:!text-zinc-100 tw:!mb-3">
            Providers
          </Heading>
          <ProviderList />
        </main>
      </div>
    </div>
  );
}
